

// Get agences (only id and nom)
export const getAgencesByWilayaSuccess =(agences)=>({
    type: "GET_AGENCES_BY_WILAYA_SUCCESS",
    payload: agences,
});